<template> 
  <div>
    <div style="padding:10px 20px;background-color:beige;border-bottom: 1px solid #ccc;">
      <h5><b>Financials</b></h5>
    </div>
    <div class="support-area">
    <section class="support-session">
      <div class="chat-session">
      </div>
    </section>
    <aside class="support-sidebar">
      <ul class="room">
        <li          
          @click="downloadFile"
        >
          <v-row>
            <v-col>
              <font-awesome-icon color="maroon" size="1x" icon="file-pdf" />
              2018 PICZ Annual Report
            </v-col>
            <v-col style="text-align:right">
              <font-awesome-icon style="text-align:right" color="green" size="1x" icon="download" />
            </v-col>
          </v-row>
        </li>
        <li          
          
        >
          <v-row>
            <v-col>
              <font-awesome-icon color="maroon" size="1x" icon="file-pdf" />
              2017 PICZ Annual Report
            </v-col>
            <v-col style="text-align:right">
              <font-awesome-icon style="text-align:right" color="green" size="1x" icon="download" />
            </v-col>
          </v-row>
        </li>
        <li          
          
        >
          <v-row>
            <v-col>
              <font-awesome-icon color="maroon" size="1x" icon="file-pdf" />
              2016 PICZ Annual Report
            </v-col>
            <v-col style="text-align:right">
              <font-awesome-icon style="text-align:right" color="green" size="1x" icon="download" />
            </v-col>
          </v-row>
        </li>
        <li          
          
        >
          <v-row>
            <v-col>
              <font-awesome-icon color="maroon" size="1x" icon="file-pdf" />
              2016 Published PICZ Financial Results
            </v-col>
            <v-col style="text-align:right">
              <font-awesome-icon style="text-align:right" color="green" size="1x" icon="download" />
            </v-col>
          </v-row>
        </li>
      </ul>
    </aside>
  </div>
  </div>
</template>
<script>
  import axios from 'axios';

  export default {
    name: 'Downloads',
    data() {
      return {
        
        
      }
    },
    methods:{
      downloadFile(){
        axios({
            url: 'http://192.168.1.71:8080/src/uploads/financials/2016_PICZ_Annual_Report.pdf',
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement('a');

              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'file.pdf');
              document.body.appendChild(fileLink);

              fileLink.click();
        });
      }
    }
  }
</script>

<style>
  .support-area {
    width: 100vw;
    height: 580px;
    display: flex;
  }

  .support-sidebar {
    width: 60%;
    background-color: beige;
    height: 100%;
    border-left: 1px solid #ccc;
    padding-top: 20px;
    border-right: 1px solid #ccc;
  }

  .support-sidebar li {
    list-style: none;
    border-bottom: 1px solid #ccc;
    padding: 0px
  }

  .support-sidebar li:hover {
    background-color: #f4f4ff;
  }

  .support-sidebar h3 {
    color: black;
    margin-bottom: 0;
    text-align: left;
    padding: 10px 20px;
    border-bottom: 1px solid #ccc;
    
  }

  .room {
    font-size: 12px;
    color: black;
    cursor: pointer;
    text-align: left;
    padding: 10px 20px;
  
  }

  .room.active {
    background-color: #eaeafd;
    color: black;
  }

  .support-session {
    width: 20%;
    height: 100%;
    display: flex;
    flex-direction: column;
 
  }

  .current-chat {
    border-bottom: 1px solid #ccc;
    text-align: left;
    padding: 10px 20px;
    display: flex;
    background-color: beige;
  }

  .current-chat h3 {
    margin-bottom: 0;
  }

  .chat-session {
    flex-grow: 1;
    overflow-y: auto;
    padding: 10px 50px;
    font-size: 12px;
  }

</style>